import { Routes } from '@angular/router';
import {LayoutComponent} from "./layout/layout.component";
import {AboutMeComponent} from "./about-me/about-me.component";

export const routes: Routes = [
    {path: '', component: LayoutComponent},
    {path: '**', component: AboutMeComponent}
];
